import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import { Friend } from "../Friend.mjs";
import { VirtualContext } from "../VirtualContext.mjs";
import mockConfig from "./config.mjs";
import createError from "./createError.mjs";
const open = function(contextID, platform) {
  return new Promise(function(resolve, reject) {
    let context = null;
    let friend = null;
    let groupPlayers = null;
    const [type, id] = contextID.split(":");
    let item = mockConfig[type][id];
    if (type === "tournament") {
      groupPlayers = [];
      const tournamentId = item ? id : void 0;
      context = VirtualContext.tournament(tournamentId);
      if (!item) {
        item = {
          name: "Tournament: " + context.id,
          players: []
        };
      }
    }
    if (!item)
      return reject(createError("INVALID_PARAM"));
    if (type === "group") {
      groupPlayers = [];
      for (const player of item.players) {
        groupPlayers.push(mockConfig.player[player]);
      }
      context = VirtualContext.group(groupPlayers, id);
    }
    if (type === "player") {
      friend = new Friend([id, item.name, item.photo]);
      context = VirtualContext.single(friend);
    }
    if (!context)
      return reject(createError("INVALID_PARAM"));
    if (platform.contextID === context.id)
      return reject(createError("SAME_CONTEXT"));
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-context-switch", overlay);
    const box = createDiv("devkit-instant-mock-context-switch-box", container);
    const closeButton = createDiv("devkit-instant-mock-closeBtn", box);
    const icons = createDiv(null, box);
    if (groupPlayers) {
      createDiv(
        "devkit-instant-mock-context-switch-icon",
        icons
      ).style.backgroundImage = "url(" + platform.playerPhoto + ")";
      for (const player of groupPlayers) {
        createDiv(
          "devkit-instant-mock-context-switch-icon",
          icons
        ).style.backgroundImage = "url(" + player.photo + ")";
      }
      createDom("h1", null, box).innerText = `Play with ${item.name}`;
    }
    if (friend) {
      createDiv(
        "devkit-instant-mock-context-switch-icon",
        icons
      ).style.backgroundImage = "url(" + platform.playerPhoto + ")";
      createDiv(
        "devkit-instant-mock-context-switch-icon",
        icons
      ).style.backgroundImage = "url(" + friend.photo + ")";
      createDom("h1", void 0, box).innerText = `Play with ${friend.name}`;
    }
    const button = createDiv(
      "devkit-instant-mock-context-choose-item-btn devkit-instant-mock-context-switch-btn",
      box
    );
    button.innerText = "Play";
    makeClickable(closeButton, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    makeClickable(button, () => {
      removeDom(overlay);
      resolve(context);
    });
  });
};
const switchAsync = { open };
export {
  switchAsync as default
};
